import { useEffect, useState } from "react";
import "./LicenseSelect.css";
import { useAuth } from "../../contexts/auth";
import ClientLicenceService from "../../services/ClientLicenceService";
import Select from "../Select/Select";

export function LicenseSelect(props) {
	const { user } = useAuth();
	const [isLoading, setIsLoading] = useState(false);
	const [clientLicences, setClientLicences] = useState([]);

	useEffect(() => {
		const getClientsLicenses = async () => {
			setIsLoading(true);
			const { data: response } = await ClientLicenceService.listClientsLicence(
				user.userData.selectedOrganizationId,
			);
			setClientLicences(response?.filter(license => !license.id_condominium || license.id_condominium === Number(props.unitId)));
			setIsLoading(false);
		};
		getClientsLicenses();
	}, [user]);

	return (
		<>
			{isLoading ? (
				<p className="loading-text">Carregando...</p>
			) : (
				<div className="license-select-container">
					{clientLicences.length === 0 ? (
						<p>Nenhuma licença disponível.</p>
					) : (
						<Select
							labelText="Licença"
							name="license"
							id="license"
							value={props.selectedLicense ?? -1}
							disabled={props.type === "consulta"}
							onChange={({ target }) => props.setSelectedLicense(Number(target.value))}
							required={true}
							options={[
								{ value: -1, text: 'Nenhuma licença' },
								...clientLicences.map(licence => {
									let text = licence.SN_equipment && licence.SN_equipment !== '' ? licence.SN_equipment : licence.tag;
									return { value: licence.id, text };
								}),
							]}
						/>
					)}
				</div>
			)}
		</>
	);
}
